import Venmo from './components/Venmo.vue';
import Home from './components/Home.vue';
import Home_old from './components/Home_old.vue';
import Corridor from './components/Corridor.vue';
import ContentPage from './components/ContentPage.vue';
import BureauChange from './components/BureauChange.vue';
import ReducePaypal from './components/ReducePaypal.vue';
import ReviewTransferwise from './components/ReviewTransferwise.vue';
import ReviewPaypal from './components/ReviewPaypal.vue';
import ReviewWestern from './components/ReviewWesternunion.vue';
import RelatedContent from './components/RelatedContent.vue';


export const routes = [
	{ path:'', component: Home},
	{ path:'/venmo', component: Venmo},
	{ path:'/open-bank-account-UK', component: ContentPage},
	{ path:'/home_v1', component: Home_old},
	{ path:'/content-page', component: ContentPage},
	{ path:'/send-money/gb', component: Corridor},
	{ path:'/review/transferwise', component: ReviewTransferwise},
	{ path:'/review/western-union', component: ReviewWestern},
	{ path:'/review/paypal', component: ReviewPaypal},
	{ path:'/bureau-de-change-a-paris-ou-trouver-le-meilleur-taux', component: BureauChange},
	{ path:'/related_content', component: RelatedContent},
	{ path:'/reduce-paypal-conversion-fees-tricks-save-money-exchange-money', component: ReducePaypal},
	{ path:'/*', component: Home}
];




// WEBPACK FOOTER //
// ./src/routes.js